import * as types from "../types/userAccountInfo"
import { getCashierAccesses, getUserAccountInfo } from "services"

export const fetchUserAccountInfo = () => (
  async (dispatch) => {

    const [
      {
        accessList,
        accessIds,
        ...userAccountDetails
      },
      {
        accessSettings: { accessSettings }
      }
    ] =
      await Promise.all([
        getUserAccountInfo(),
        getCashierAccesses()
      ])

    const cashierPin =
      accessSettings.find(accessSetting =>
        accessSetting.accountId ===
        userAccountDetails._id
      )?.pin
      ||
      ""

    const hasFullAccess =
      accessList.some(access => access.hasFullAccess)

    const accesses = { accessIds, hasFullAccess }

    accessList.forEach(access => {
      access.endpoints.forEach(endpoint => {
        if (!endpoint.tag) return

        accesses[endpoint.tag] = endpoint.tag
      })
    })

    //prevent duplicate branch
    const cashierBranchesMap = {}

    accessList.forEach(access => {
      access.branches.forEach(accessBranch => {
        cashierBranchesMap[accessBranch._id] = accessBranch
      })
    })

    const cashierBranches =
      Object.keys(cashierBranchesMap).map(branchId => ({
        branchId,
        ...cashierBranchesMap[branchId]
      }))

    dispatch({
      type: "FETCH_USER_INFO",
      userAccountInfo: {
        ...userAccountDetails,
        cashierPin,
        accesses,
        cashierBranches
      }
    })
  }
)

export const updateUserAccountInfo = userAccountInfo => ({
  type: types.UPDATE_USER_INFO,
  userAccountInfo
})

export const deleteUserAccountInfo = () => ({
  type: types.DELETE_USER_INFO
})